import { useState, useEffect, useRef } from 'react';
import { Search } from 'lucide-react';
import DynamicIcon from './dynamic-icon';
import { useTranslations } from "next-intl";


const SearchModalInput = ({
    placeholder = 'Search',
    value = '',
    onChange = () => { },
    onSubmit = () => { },
    onAskAi = () => { },
    autoFocus = true,
    className = '',
}) => {
    const [query, setQuery] = useState(value);
    const inputRef = useRef(null);
    const t = useTranslations('generalSearch');

    useEffect(() => {
        if (autoFocus && inputRef.current) {
            inputRef.current.focus();
        }
    }, [autoFocus]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setQuery(newValue);
        onChange(newValue);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(query);
    };

    const handleClear = () => {
        setQuery('');
        onChange('');
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const handleAskAi = () => {
        if (query.trim()) {
            onAskAi(query);
        }
    };

    return (
        <form onSubmit={handleSubmit} className={`relative ${className} py-[7.5px] px-[12px]`}>
            <div className="relative flex items-center">
                <div className='flex items-center w-full gap-[8px]'>
                    <DynamicIcon name='search' color="custom-text-grey-200" size={20} />
                    <input
                        ref={inputRef}
                        type="text"
                        value={query}
                        onChange={handleChange}
                        placeholder={placeholder}
                        className="h-[21px] w-full bg-[transparent] outline-none placeholder-text-grey-200 dark:placeholder-text-white-dark-200 poppins-regular text-[14px] custom-text-grey-900"
                    />
                </div>

                <div 
                    onClick={handleAskAi}
                    className='flex items-center gap-[4px] px-[10px] py-[11.5px] custom-bg-white-200 cursor-pointer poppins-medium custom-text-grey-900 text-[13px] rounded-[8px] whitespace-nowrap'
                >
                    <DynamicIcon name='sparkles' size={14} color='custom-text-grey-900' />
                    {t('askAi')}
                </div>
            </div>
        </form>
    );
};

export default SearchModalInput;